import { IonImg, IonGrid, IonRow, IonCol, IonButton } from '@ionic/react';
import { Link, useHistory } from 'react-router-dom';
import React, { useState } from 'react';
import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { connect, useSelector } from 'react-redux';
import './Home.scss';
import { RootState } from '../../models/RootState';
import HomeView from '../../constants/HomeView';
import Footer from '../Footer/Footer';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { casinoGameSelected, setDcGameUrl } from '../../store';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';
import iplImg from '../../assets/images/home/ipl.png';
// import bblwomens from '../../assets/images/home/bbl_women.png';

import { WORLD_CUP } from '../../constants/IPLEvent';

const Headings = HomeView.HOME_PAGE_HEADERS;
const Images = HomeView.HOME_PAGE_IMAGES;
const WebBanners = HomeView.HOME_PAGE_WEB_BANNERS;
const MobBanners = HomeView.HOME_PAGE_MOB_BANNERS;
const TvGames = HomeView.HOME_PAGE_TV_GAMES;
const LiveGames = [
  Images.andarBahar,
  Images.teenpatti,
  Images.blackjack,
  Images.baccarat,
  Images.roulette,
  Images.poker,
  Images.vip_roulette,
  Images.dream_catcher,
];

const HomePageGames = HomeView.HOME_PAGE_GAMES;
const SportsBook = [Images.cricket, Images.football, Images.tennis];
const CasinoCards = HomeView.HOME_PAGE_CASINO_TILES;

type StoreProps = {
  casinoGameSelected: (game: { id: string; name: string }) => void;
  setDcGameUrl: (url: string) => void;
  loggedIn: boolean;
  allowedConfig: number;
};

const Home: React.FC<StoreProps> = (props) => {
  const { loggedIn, allowedConfig } = props;
  const langData=useSelector((state:RootState)=> state.common.langData)
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalTitle] = useState('Login');
  const [redirectUrl] = useState<string>('');
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const history = useHistory();

  const modalCloseHandler = () => {
    setModalOpen(false);
  };
  
  const getGameUrl = async (gameInfo: string, gameName: string) => {
    if (loggedIn) {
      const gameId = parseInt(gameInfo.split(':')[0], 10);
      const gameCode = gameInfo.split(':')[1];
      const provider = gameInfo.split(':')[2];
      const subProvider = gameInfo.split(':')[3];
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setShowDialog(true);
    }
  };

  const navigateToLink = (url) => {
    if (url.includes('/casino')) {
      if (ALLOW_CASINO) history.push(url);
    } else {
      history.push(url);
    }
  };

  const getBanners = (device: 'mobile' | 'web') => {
    if (device === 'mobile') {
      return MobBanners.filter(
        (m) => (m.configPermission & allowedConfig) !== 0
      );
    } else {
      return WebBanners.filter(
        (m) => (m.configPermission & allowedConfig) !== 0
      );
    }
  };

  return (
    <>
      <div>
        <Carousel
          className="web-banners"
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showThumbs={false}
          showStatus={false}
        >
          {getBanners('web').map((banner) => (
            <div key={banner.text + 'container'}>
              <img
                onClick={() => navigateToLink(banner.url)}
                className="banner-images"
                src={banner.image}
                key={banner.text + 'image'}
                alt={banner.text}
                title={banner.text}
              />
            </div>
          ))}
        </Carousel>

        <Carousel
          className="mob-banners"
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showThumbs={false}
          showStatus={false}
        >
          {getBanners('mobile').map((banner) => (
            <div key={banner.text + 'container'}>
              <img
                onClick={() => navigateToLink(banner.url)}
                className="banner-images"
                src={banner.image}
                key={banner.text + 'image'}
                alt={banner.text}
                title={banner.text}
              />
            </div>
          ))}
        </Carousel>

        <IonGrid class="home-grid">
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <>
              <IonRow className="sports">
                <IonCol size="12" class="sports-header">
                  <div className="sports-text">{langData?.['sports']}</div>
                  <Link className="more-link" to="/exchange_sports">
                    <IonButton color="primary" size="small">
                    {langData?.['browse_all_txt']}
                    </IonButton>
                  </Link>
                </IonCol>
              </IonRow>
              <IonRow class="sports-book">
                {SportsBook.map((sport) =>
                  (EXCH_SPORTS_MAP[sport.text.toLowerCase()] &
                    allowedConfig) !==
                  0 ? (
                    <IonCol
                      sizeXs="6"
                      sizeSm="6"
                      sizeMd="3"
                      sizeLg="3"
                      class="sport"
                      key={sport.text}
                    >
                      <Link to={sport.url} className="decoration-none">
                        <IonImg
                          className="grid-images sport-images"
                          src={sport.image}
                          alt={sport.text}
                          title={sport.text}
                        />
                        <Card key={sport.text} className="game-card sport-card">
                          <CardActionArea>
                            <CardContent className="dc-card-ctn">
                              <Typography gutterBottom className="game-name">
                                {sport.text.toUpperCase()}
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Link>
                    </IonCol>
                  ) : null
                )}

                <IonCol
                  sizeXs="6"
                  sizeSm="6"
                  sizeMd="3"
                  sizeLg="3"
                  class="sport"
                  key={'virual'}
                >
                  <Link to={`/virtual_sports`} className="decoration-none">
                    <IonImg
                      className="grid-images sport-images"
                      src={iplImg}
                      alt={'virual'}
                      title={'virual'}
                    />
                    <Card key={'virual'} className="game-card sport-card">
                      <CardActionArea>
                        <CardContent className="dc-card-ctn">
                          <Typography gutterBottom className="game-name">
                            {'VIRTUAL_SPORTS'}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Link>
                </IonCol>
              </IonRow>
            </>
          ) : null}
          {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
            <>
              <IonRow class="live-games">
                <IonCol size="12" className="live-games-header">
                  <div className="live-games-text">{langData?.['live_games']}</div>
                  {ALLOW_CASINO ? (
                    <Link className="more-link" to="/casino">
                      <IonButton color="primary" size="small">
                      {langData?.['browse_all_txt']}
                      </IonButton>
                    </Link>
                  ) : (
                    <IonButton color="primary">{langData?.['browse_all_txt']}</IonButton>
                  )}
                </IonCol>
                {LiveGames.map((game, idx) => (
                  <IonCol
                    sizeXs="6"
                    sizeSm="6"
                    sizeMd="3"
                    sizeLg="3"
                    class="live-game"
                    key={game.text}
                  >
                    <Card
                      key={'incasino-game-' + idx}
                      className="dc-ion-card"
                      onClick={() => {
                        if (ALLOW_CASINO) getGameUrl(game.id, game.text);
                      }}
                    >
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          alt={game.text}
                          className="dc-card-media"
                          image={game.image ? game.image : ''}
                          title={game.text}
                        />
                        <CardContent className="dc-card-ctn">
                          <Typography gutterBottom className="game-name">
                            {game.text}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </IonCol>
                ))}
              </IonRow>
              <IonRow class="live-games casino-cards">
                <IonCol size="12" className="live-games-header cards-header">
                  <div className="live-games-text cards-text casino-hub">
                  {langData?.['providers']}
                  </div>
                </IonCol>
                <Tabs
                  variant="scrollable"
                  scrollButtons="on"
                  className="gametypes-tabs"
                  textColor="primary"
                  centered={true}
                  orientation="horizontal"
                >
                  {CasinoCards.map((card, idx) => (
                   <Link to={`/casino?filteredProvider=${card.Provider}`} key={card.Provider}>
                      <Tab
                        value={0}
                        textColor="primary"
                        className="hub-card"
                        icon={<img src={card.image} title={card.text} />}
                      />
                    </Link>
                  ))}
                </Tabs>
              </IonRow>
            </>
          ) : null}
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <IonRow class="live-games">
              <IonCol size="12" className="live-games-header cards-header">
                <div className="live-games-text cards-text">
                {langData?.['games']}
                </div>
              </IonCol>
              <div className="games-row">
                {HomePageGames.map((game, idx) => (
                  <>
                    {isMobile && idx >= 12 ? null : (
                      <>
                        {allowedConfig & game.id ? (
                          <Link to={game.url} className="decoration-none">
                            <Card
                              key={'incasino-game-' + idx}
                              className="game-card"
                            >
                              <CardActionArea>
                                <CardMedia
                                  component="img"
                                  alt={game.text}
                                  className="game-card-media"
                                  image={game.image ? game.image : ''}
                                  title={game.text}
                                />
                                <CardContent className="game-card-ctn">
                                  <Typography
                                    gutterBottom
                                    className="game-name"
                                  >
                                    {langData?.[game.langKey]}
                                  </Typography>
                                </CardContent>
                              </CardActionArea>
                            </Card>
                          </Link>
                        ) : null}
                      </>
                    )}
                  </>
                ))}
              </div>
            </IonRow>
          ) : null}
          {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
            <IonRow class="live-games">
              <IonCol size="12" className="live-games-header">
                <div className="live-games-text">{langData?.['tv_games']}</div>
                {ALLOW_CASINO ? (
                  <Link className="more-link" to="/tv_games">
                    <IonButton color="primary" size="small">
                    {langData?.['browse_all_txt']}
                    </IonButton>
                  </Link>
                ) : (
                  <IonButton color="primary">{langData?.['browse_all_txt']}</IonButton>
                )}
              </IonCol>
              {TvGames.map((game, idx) => (
                <IonCol
                  sizeXs="6"
                  sizeSm="6"
                  sizeMd="3"
                  sizeLg="3"
                  class="live-game"
                  key={game.text}
                >
                  <Card
                    key={'incasino-game-' + idx}
                    className="dc-ion-card"
                    onClick={() => {
                      if (ALLOW_CASINO) getGameUrl(game.id, game.text);
                    }}
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        alt={game.text}
                        className="dc-card-media"
                        image={game.image ? game.image : ''}
                        title={game.text}
                      />
                    </CardActionArea>
                  </Card>
                </IonCol>
              ))}
            </IonRow>
          ) : null}
        </IonGrid>
        <Footer></Footer>
      </div>
      <Modal
        open={modalOpen}
        title={modalTitle}
        closeHandler={modalCloseHandler}
        size="xs"
      >
        <LoginForm
          modalCloseHandler={modalCloseHandler}
          redirectUrl={redirectUrl}
        ></LoginForm>
      </Modal>
      <Dialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        aria-labelledby="form-dialog-title"
      >
         <DialogTitle id="form-dialog-title">{langData?.['notice']}</DialogTitle>
        <DialogContent>
          <div className="dc-dialog-body"> {langData?.['login_to_play_txt']}</div>
        </DialogContent>
        <DialogActions className="dc-dialog-actions">
          <Button
            onClick={() => setShowDialog(false)}
            color="primary"
            autoFocus
          >
             {langData?.['ok']}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    casinoGameSelected: (game: { id: string; name: string }) =>
      dispatch(casinoGameSelected(game)),
    setDcGameUrl: (url: string) => dispatch(setDcGameUrl(url)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
